import React from 'react';
import Icon from '../../../components/AppIcon';

const TermsHeader = ({ effectiveDate, version, lastUpdated }) => {
  return (
    <div className="mb-8 rounded-lg bg-muted p-6">
      <div className="mb-4 flex items-center space-x-2">
        <Icon name="FileText" size={24} color="var(--color-primary)" />
        <h1 className="text-2xl font-bold text-foreground">서비스 이용약관</h1>
      </div>
      <div className="space-y-2 text-sm text-text-secondary">
        <div className="flex items-center space-x-2">
          <Icon name="Calendar" size={16} />
          <span>시행일: {effectiveDate}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="GitBranch" size={16} />
          <span>버전: {version}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Clock" size={16} />
          <span>최종 수정일: {lastUpdated}</span>
        </div>
      </div>
    </div>
  );
};

export default TermsHeader;